module.exports = __webpack_public_path__ + "static/media/scale.tar.b7b8729d.gz";